module.exports = __webpack_public_path__ + "static/media/Capacidad60-p.3659a8a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/Capacidad60-p.svg
// module id = 151
// module chunks = 0